import { KeyValue } from "../../../../interfaces";

export const transformDataForDownload = (
  countyDataObj: KeyValue,
  lastYear: string,
  countySumMap: KeyValue,
  stname: string | undefined,
  institByCert: KeyValue,
  stateData: KeyValue,
  county: string,
) => {
  const response: KeyValue[] = [];
  if (county) {
    countyDataObj[county].forEach((obj: KeyValue) => {
      const currentCert = obj.CERT;
      const map: KeyValue = {};
      countySumMap.forEach((elem: KeyValue) => {
        map[elem.CNTYNAMB] = elem.sum_DEPSUMBR;
      });
      const share = obj.sum_DEPSUMBR / map[county];
      let institutionName = "";
      if (
        institByCert.hasOwnProperty(county) &&
        institByCert[county].hasOwnProperty(currentCert)
      ) {
        institutionName = institByCert[county][currentCert];
      }
      const data = {
        "Report Period": lastYear,
        "State": stname,
        "County": county,
        "Institution Name": institutionName,
        "Institution Count / CERT": obj.CERT,
        "Office Count": obj.count,
        "Total Deposits (Thousands USD)": obj.sum_DEPSUMBR.toLocaleString(),
        "Market Share": `${(share * 100).toFixed(2)}%`,
      };
      response.push(data);
    });
  } else {
    countySumMap.forEach((county: KeyValue) => {
      const data = {
        "Report Period": lastYear,
        "State": stname,
        "County": county.CNTYNAMB,
        "Institution Count / CERT": county.unique_count,
        "Office Count": county.count,
        "Total Deposits (Thousands USD)": county.sum_DEPSUMBR.toLocaleString(),
        "Market Share": `${(
          (county.sum_DEPSUMBR / stateData.sum_DEPSUMBR) *
          100
        ).toFixed(2)}%`,
      };
      response.push(data);
    });
  }
  let totalsData: KeyValue = {};
  if (county) {
    let filteredData: KeyValue = {};
    filteredData = countySumMap.filter(
      (item: KeyValue) => item.CNTYNAMB === county,
    );
    totalsData = {
      "Report Period": lastYear,
      "State": stname,
      "County": county,
      "Institution Name": "Totals",
      "Institution Count / CERT": filteredData[0].unique_count,
      "Office Count": filteredData[0].count,
      "Total Deposits (Thousands USD)": filteredData[0].sum_DEPSUMBR?.toLocaleString(),
      "Market Share": "100.00%",
    };
  } else {
    totalsData = {
      "Report Period": lastYear,
      "State": stname,
      "County": "Totals",
      "Institution Count / CERT": stateData.unique_count,
      "Office Count": stateData.count,
      "Total Deposits (Thousands USD)": stateData.sum_DEPSUMBR?.toLocaleString(),
      "Market Share": "100.00%",
    };
  }

  response.push(totalsData);
  return response;
};

export const removeDuplicates = (array: KeyValue[], key: string) => {
  const uniqueIds = new Set();
  return array.filter(obj => {
    if (!uniqueIds.has(obj[key])) {
      uniqueIds.add(obj[key]);
      return true;
    }
    return false;
  });
};
